/**
 *Created by jmmartinez on 01/06/2026
 * 01/06/2026 v1.1 Mejorada la comprobacion de tipos basada en extensiones
 */

import React from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import PropTypes from "prop-types";

class SelectorDocumento extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            archivoOriginal: null,
            previewUrl: null,
            crop: { unit: "%", x: 10, y: 10, width: 80, height: 80},
            completedCrop: null,
            imagenRecortada: null,
            previewFinal: null,
            tieneCamara: false,
            mostrarCamara: false,
            subiendo: false,
            origenArchivo: null, // "camara" | "archivo"
            nombreArchivoBase: "",
            nombreArchivo: "",
            esImagen: false
        };
        this.imageRef = null;
        this.videoRef = React.createRef();
        this.stream = null;
    }

    async componentDidMount() {
            if (!this.props.permitirCamara)
                return;
            let tieneCamara = false;
            try {
                if (navigator.mediaDevices &&
                    navigator.mediaDevices.getUserMedia) {

                    // intento silencioso SOLO para detectar soporte
                    const stream = await navigator.mediaDevices.getUserMedia({
                        video: true
                    });

                    tieneCamara = true;
                    // cerramos inmediatamente
                    stream.getTracks().forEach(t => t.stop());
                }
            } catch (e) {
                // si falla permisos o no hay cámara, simplemente no hay cámara
                tieneCamara = false;
            }
            this.setState({ tieneCamara });
    }


    componentWillUnmount() {
        if (this.state.previewUrl) {
            URL.revokeObjectURL(this.state.previewUrl);
        }
        if (this.state.previewFinal) {
            URL.revokeObjectURL(this.state.previewFinal);
        }
        this.cerrarCamara();
    }

    estaBloqueado = () => {
        return this.state.subiendo;
    }
    abrirCamara = async () => {
        if (!this.props.permitirCamara)
            return;

        if (this.estaBloqueado())
            return;

        try {
            this.stream =  await navigator.mediaDevices.getUserMedia({video: {facingMode: { ideal: "environment" } }  });
            this.setState({mostrarCamara: true}, () => {
                const video = this.videoRef.current;
                if (video) {
                    video.setAttribute("playsinline", true);
                    video.srcObject = this.stream;
                    const playPromise = video.play();
                    if (playPromise && playPromise.catch) {
                        playPromise.catch((e) => {
                            console.warn("Error al reproducir video:", e);
                        });
                    }
                }
            });
        } catch (e) {
            let error= "Error cámara: " + (e.name || "") + " - " + (e.message || e.toString());
            alert( error);
        }
    }

    cerrarCamara = () => {
        if (this.stream) {

            this.stream
                .getTracks()
                .forEach(track => track.stop());

            this.stream = null;
        }

        this.setState({
            mostrarCamara: false
        });
    }

    capturarFoto = () => {

        if (this.estaBloqueado())
            return;

        const video = this.videoRef.current;
        const canvas=  document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage( video,0, 0);

        canvas.toBlob(
            (blob) => {
                const archivo =
                    new File(
                        [blob],
                        "foto.jpg",
                        {
                            type: "image/jpeg"
                        }
                    );

                if (this.state.previewUrl) {
                    URL.revokeObjectURL(this.state.previewUrl);
                }
                const previewUrl = URL.createObjectURL(archivo);

                this.setState({
                    archivoOriginal: archivo,
                    previewUrl,
                    imagenRecortada: null,
                    previewFinal: null,
                    completedCrop: null,
                    origenArchivo: "camara",
                    esImagen: true
                });
                this.cerrarCamara();
            },
            "image/jpeg",
            0.9
        );
    }

    onSeleccionArchivo = (e) => {
        if (this.estaBloqueado())
            return;

        const {acceptTypes, onFileError} = this.props;
        const archivo = e.target.files[0];
        if (!archivo)
            return;

        //Comprobamos los tipos
        const tiposPermitidos = acceptTypes
            .split(",")
            .map(t => t.trim().toLowerCase());
        const nombreArchivo = archivo.name.toLowerCase();
        const mimeArchivo = (archivo.type || "").toLowerCase();
        const esImagen = mimeArchivo.startsWith("image/");

        const esValido = tiposPermitidos.some(tipo => {
            // Extensión
            if (tipo.startsWith(".")) {
                return nombreArchivo.endsWith(tipo);
            }
            // Wildcard: image/*
            if (tipo.endsWith("/*")) {
                const prefijo = tipo.substring(0, tipo.length - 1);
                return mimeArchivo.startsWith(prefijo);
            }
            // MIME exacto
            return mimeArchivo === tipo;
        });

        if (!esValido) {
            let error= "Tipo de archivo no permitido: " + archivo.type;
            onFileError && onFileError(error);
            alert(error);
            e.target.value = null;
            return;
        }

        //Pintamos la previe
        if (this.state.previewUrl) {
            URL.revokeObjectURL(this.state.previewUrl);
        }
        const previewUrl = URL.createObjectURL(archivo);
        this.setState({
            archivoOriginal: archivo,
            nombreArchivo: archivo.name,
            previewUrl,
            imagenRecortada: null,
            previewFinal: null,
            completedCrop: null,
            origenArchivo: "archivo",
            esImagen
        });
    }

    onImageLoaded = (img) => {
        this.imageRef = img;
    }

    getImagenRecortada = async () => {
        const {completedCrop, nombreArchivo, nombreArchivoBase, origenArchivo} = this.state;

        if (!completedCrop || !this.imageRef)
            return null;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const scaleX = this.imageRef.naturalWidth / this.imageRef.width;
        const scaleY = this.imageRef.naturalHeight / this.imageRef.height;

        let width = completedCrop.width * scaleX;
        let height = completedCrop.height * scaleY;

        const maxWidth = 1200;
        const maxHeight = 1200;

        if (width > maxWidth) {
            height = height * (maxWidth / width);
            width = maxWidth;
        }

        if (height > maxHeight) {
            width = width * (maxHeight / height);
            height = maxHeight;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(
            this.imageRef,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            width,
            height
        );

        let nombreFinal = "foto.jpg";
        if (origenArchivo === "archivo") {
            nombreFinal = nombreArchivo || "archivo.jpg";
        }
        if (origenArchivo === "camara") {
            const base =
                (nombreArchivoBase && nombreArchivoBase.trim() !== "")
                    ? nombreArchivoBase.trim()
                    : "foto";
            nombreFinal = base + ".jpg";
        }

        return new Promise((resolve) => {
            canvas.toBlob(
                (blob) => {
                    const nombreBase = nombreArchivo || "foto.jpg";
                    const archivo = new File(
                        [blob],
                        nombreFinal,
                        {type: "image/jpeg"}
                    );
                    resolve(archivo);
                },
                "image/jpeg",
                0.7
            );
        });
    }

    procesarImagen = async () => {

        if (!this.state.esImagen) {
            this.setState({
                imagenRecortada: this.state.archivoOriginal,
                previewFinal: null
            });
            return;
        }

        const archivoComprimido = await this.getImagenRecortada();
        if (!archivoComprimido)
            return;
        if (this.state.previewFinal) {
            URL.revokeObjectURL(this.state.previewFinal);
        }
        const previewFinal = URL.createObjectURL(archivoComprimido);

        const esCamara = this.state.origenArchivo === "camara";
        this.setState({
            imagenRecortada: archivoComprimido,
            previewFinal,
            mostrarNombreArchivo: esCamara,
        });
        console.log("Peso final KB:", archivoComprimido.size / 1024);
    }

    subirArchivoOld = async () => {
        const {imagenRecortada, origenArchivo, nombreArchivo} = this.state;
        const {uploadUrl, onFileUploaded, onFileError} = this.props;

        if (this.estaBloqueado())
            return;

        this.setState({ subiendo: true });

        if (!imagenRecortada) {
            const error = "Debe procesar la imagen";
            onFileError && onFileError(error);
            alert(error);
            return;
        }

        const formData = new FormData();
        formData.append("file", imagenRecortada);
        try {
            const response = await fetch(uploadUrl, {
                method: "POST",
                body: formData
            });
            if (!response.ok) {
                const error = "Error HTTP " + response.status;
                onFileError && onFileError(error);
            }
            else {
                const resultado = await response.json();
                console.log("Subido:", resultado);
                onFileUploaded && onFileUploaded(resultado, imagenRecortada);

                setTimeout(() => {
                    this.resetEstado();
                }, 300);
                //alert("Imagen subida correctamente");
            }
        } catch (e) {
            console.error(e);
            const error= "Error subiendo imagen " + e.toString();
            onFileError && onFileError(error);
            alert(error);
        }finally {
            this.setState({ subiendo: false });
        }
    }

    subirArchivo = async () => {

        const {imagenRecortada, nombreArchivoBase, origenArchivo} = this.state;
        const {uploadUrl, onFileUploaded, onFileError} = this.props;
        console.log("SUBIR ARCHIVO");

        if (!imagenRecortada) {
            const error = "Debe procesar la imagen";
            onFileError && onFileError(error);
            return;
        }

        let archivoFinal = imagenRecortada;
        if (origenArchivo === "camara") {
            const base = (nombreArchivoBase && nombreArchivoBase.trim() !== "")
                    ? nombreArchivoBase.trim()
                    : "foto";
            const nombreFinal = base + ".jpg";

            archivoFinal = new File(
                [imagenRecortada],
                nombreFinal,
                { type: "image/jpeg" }
            );
        }

        this.setState({ subiendo: true });

        const formData = new FormData();
        formData.append("file", archivoFinal);
        try {
            const response = await fetch(uploadUrl, {
                method: "POST",
                body: formData
            });
            const resultado = await response.json();
            onFileUploaded &&  onFileUploaded(resultado, archivoFinal);
            this.resetEstado();
        } catch (e) {
            const error = e.message || e.toString();
            onFileError && onFileError(error);
        } finally {
            this.setState({ subiendo: false });
        }
    }


    resetEstado = () => {
        if (this.state.previewUrl) {
            URL.revokeObjectURL(this.state.previewUrl);
        }

        if (this.state.previewFinal) {
            URL.revokeObjectURL(this.state.previewFinal);
        }

        this.imageRef = null;
        this.setState({
            archivoOriginal: null,
            previewUrl: null,
            crop: {unit: "%", x: 10, y: 10, width: 80, height: 80 },
            completedCrop: null,
            imagenRecortada: null,
            previewFinal: null,
            mostrarCamara: false,
            mostrarNombreArchivo: false,
            nombreArchivo: "",
            origenArchivo: null
        });
    }

    render() {
        const {previewUrl, crop, previewFinal, tieneCamara, mostrarCamara, mostrarNombreArchivo, nombreArchivoBase, subiendo} = this.state;
        const {titulo, acceptTypes, permitirCamara} = this.props;

        const bloqueado = subiendo;

        return (
            <div className="selector-documento">
                <h3>{titulo}</h3>
                <div>
                    <label>Seleccionar archivo: </label>
                    <input disabled={bloqueado} type="file" accept={acceptTypes} onChange={this.onSeleccionArchivo}  />
                </div>
                {   permitirCamara && tieneCamara &&
                    <div style={{marginTop:"10px"}}>
                        <button type="button" disabled={bloqueado} onClick={this.abrirCamara}>Hacer foto</button>
                    </div>
                }

                {   mostrarCamara &&
                    <div style={{marginTop:"20px"}}>
                        <video ref={this.videoRef} autoPlay playsInline style={{width:"100%", maxWidth:"600px"}} />
                        <div style={{marginTop:"10px"}}>
                            <button type="button"  disabled={bloqueado} onClick={this.capturarFoto}>Capturar </button>
                            <button type="button" onClick={this.cerrarCamara} style={{marginLeft:"10px"}}>Cancelar</button>
                        </div>
                    </div>
                }

                {previewUrl && this.state.esImagen &&
                    <div style={{marginTop:"20px"}}>
                        <ReactCrop
                            crop={crop}
                            onChange={(crop) => this.setState({crop})}
                            onComplete={(completedCrop) => this.setState({completedCrop})}
                        >
                            <img
                                src={previewUrl}
                                alt=""
                                onLoad={(e) => this.onImageLoaded(e.currentTarget)}
                                style={{maxWidth:"100%", maxHeight:"600px"}}
                            />
                        </ReactCrop>
                    </div>
                }

                {previewUrl && this.state.esImagen &&
                    <button
                        disabled={bloqueado}
                        onClick={this.procesarImagen}
                        style={{marginTop:"20px"}}
                    >
                        Recortar y comprimir
                    </button>
                }

                {   previewFinal &&
                    <div style={{marginTop:"20px"}}>
                        <div>Resultado:</div>
                        <img src={previewFinal} alt="preview" style={{maxWidth:"300px", border:"1px solid #ccc", marginTop:"10px" }} />
                    </div>
                }

                { mostrarNombreArchivo &&
                    <div style={{marginTop:"15px"}}>
                        <label>Nombre del archivo:</label>
                        <input
                            type="text"
                            value={nombreArchivoBase}
                            onChange={(e) =>
                                this.setState({ nombreArchivoBase: e.target.value})
                            }
                        />
                        <span style={{marginLeft:"6px"}}>.jpg</span>
                    </div>
                }

                {   previewFinal &&
                    <button disabled={bloqueado} onClick={this.subirArchivo} style={{marginTop:"20px"}}>
                        {subiendo ? "Subiendo..." : "Subir imagen"} </button>
                }
            </div>
        );
    }
}
SelectorDocumento.defaultProps = {
    acceptTypes: "image/jpeg,image/png,application/pdf",
    permitirCamara: false,
    titulo: "DOCUMENTO / FOTO",
};

SelectorDocumento.propTypes = {
    uploadUrl: PropTypes.string.isRequired,
    titulo: PropTypes.string,
    onFileUploaded: PropTypes.func,
    onFileError: PropTypes.func,
    acceptTypes: PropTypes.string,
    permitirCamara: PropTypes.bool,
}



export default SelectorDocumento;